/* unplugin-vue-components disabled */import script from "./BatchAddSupplierOwnerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchAddSupplierOwnerModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__